module.exports = __webpack_public_path__ + "img/costBlue.a4da4491.png";